import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { FiltroControllerService } from 'src/app/services/filtro-controller.service';
import { trigger, style, animate, transition, state } from '@angular/animations';
import { CotacoesPDocs } from 'src/app/models/cotacoes.model';
@Component({
  selector: 'filtro-cotacoes-ramo',
  templateUrl: './cotacoes-ramo.component.html',
  styleUrls: ['./cotacoes-ramo.component.scss'],
  animations : [
    trigger('animationRotate', [
      state('close', style({ transform: 'rotate(0)' })),
      state('open', style({ transform: 'rotate(-180deg)' })),
      transition('open <=> close', animate('400ms ease-in-out')),
    ]),
    trigger('animationShowHide', [
      state('close', style({ height: '0px', overflow: 'hidden' })),
      state('open', style({ height: '*' })),
      transition('open <=> close', animate('400ms ease-in-out')),
    ])
  ]
})
export class CotacoesRamoComponent implements OnInit {
  @Output('eventFilter') eventFilter = new EventEmitter();
  @Output('clearFilter') limpaFiltro = new EventEmitter();
	// @Input('listaUsuarios') listaUsuarios = [];
  @Input('listaUsuarios') listaUsuarios:any = {};
  listaStatusNegocio = new CotacoesPDocs().getAllCotacaoStatus();

  filtroUsuario =  false;
  filtroUsuarioExpandido = true;
  filtroStatusNegocio = [];
  filtroStatusNegocioExpandido = false;
  constructor(public filtroController: FiltroControllerService) { }

  ngOnInit() {
    this.inicializaFiltros();
  }

  buildString() {
    this.filtroController.addFiltrosExtras('cotacoes', (this.filtroUsuario || this.filtroStatusNegocio.length) ? 
    { usuario: this.filtroUsuario, listaStatusNegocio: this.filtroStatusNegocio } : 0);
    let rawValue = {
      usuario: this.filtroController.filtroCotacoes.usuario,
      listaStatusNegocio: this.filtroController.filtroCotacoes.listaStatusNegocio
    };
    let filtros = { values: rawValue };
    this.eventFilter.emit(filtros);
    this.filtroController.verificaFiltro();
  }

  clearFilter() {
    this.filtroUsuario = false;
    this.limpaFiltroStatusNegocio();
    this.filtroController.limparFiltro('cotacoes');
    this.limpaFiltro.emit();
    this.filtroController.verificaFiltro();
    this.buildString();
  }

  inicializaFiltros(){
    if(this.filtroController.filtroCotacoes){
      this.filtroUsuario = this.filtroController.filtroCotacoes.usuario;
      this.filtroStatusNegocio = this.filtroController.filtroCotacoes.listaStatusNegocio;
      this.verificaStatusNegocioSelecionado();
    }
  }

  atualizaFiltroStatusNegocio(negocio, newValue) {
    for (let status of this.listaStatusNegocio) {
      if (status.value == negocio) {
        if (newValue) {
          this.filtroStatusNegocio.push(negocio);
        } else {
          let index = this.filtroStatusNegocio.findIndex(s => s == negocio);
          this.filtroStatusNegocio.splice(index, 1);
        }
      }
    }
  }

  limpaFiltroStatusNegocio() {
    this.filtroStatusNegocio = [];
    for(let item of this.listaStatusNegocio) {
      item['ativo'] = false;
    }
  }

  verificaStatusNegocioSelecionado() {
		for (let item of this.listaStatusNegocio) {
			for (let id of this.filtroStatusNegocio) {
				if (item.value === id) {
					item['ativo'] = true;
				}
			}
		}
	}
}
